import React from 'react'
import { Box } from '@mui/material'
export interface Props {
  page: number
  totalPages: number
  handlePagination: (page: number) => void
}
export const PaginationComponent: React.FC<Props> = ({
  page,
  totalPages,
  handlePagination
}) => {
  const baseButtonSx = {
    background: 'transparent',
    border: 'none',
    height: '2rem',
    width: '2rem',
    margin: '0 0.25rem',
    borderRadius: '50%',
    fontWeight: 'bold',
    color: '#004bb1',
    cursor: 'pointer'
  }
  const activeSx = {
    backgroundColor: '#004bb1',
    color: '#ffffff'
  }
  const sidesSx = {
    boxShadow:
      'transparent 0px 0px 0px 1px, transparent 0px 0px 0px 4px, rgba(0, 0, 0, 0.18) 0px 2px 4px'
  }
  return (
    <div className={'pagination'}>
      <Box sx={{ pt: '0.5rem', pb: '1rem', display: 'flex', justifyContent: 'center' }}>
        {page !== 1 && (
          <Box
            component='button'
            onClick={() => handlePagination(page - 1)}
            type='button'
            sx={{ ...baseButtonSx, ...sidesSx }}
          >
            &lt;
          </Box>
        )}
        <Box
          component='button'
          onClick={() => handlePagination(1)}
          type='button'
          sx={{ ...baseButtonSx, ...(page === 1 ? activeSx : {}) }}
        >
          {1}
        </Box>
        {page > 3 && <Box sx={{ width: '1rem', margin: '0 0.25rem' }}>...</Box>}
        {page === totalPages && totalPages > 3 && (
          <Box
            component='button'
            onClick={() => handlePagination(page - 2)}
            type='button'
            sx={baseButtonSx}
          >
            {page - 2}
          </Box>
        )}
        {page > 2 && (
          <Box
            component='button'
            onClick={() => handlePagination(page - 1)}
            type='button'
            sx={baseButtonSx}
          >
            {page - 1}
          </Box>
        )}
        {page !== 1 && page !== totalPages && (
          <Box
            component='button'
            onClick={() => handlePagination(page)}
            type='button'
            sx={{ ...baseButtonSx, ...activeSx }}
          >
            {page}
          </Box>
        )}
        {page < totalPages - 1 && (
          <Box
            component='button'
            onClick={() => handlePagination(page + 1)}
            type='button'
            sx={baseButtonSx}
          >
            {page + 1}
          </Box>
        )}
        {page === 1 && totalPages > 3 && (
          <Box
            component='button'
            onClick={() => handlePagination(page + 2)}
            type='button'
            sx={baseButtonSx}
          >
            {page + 2}
          </Box>
        )}
        {page < totalPages - 2 && (
          <Box sx={{ width: '1rem', margin: '0 0.25rem' }}>...</Box>
        )}
        {/* Si la pagina es uno, el número de última página no se muestra */}
        {page !== 1 && (
          <Box
            component='button'
            onClick={() => handlePagination(totalPages)}
            type='button'
            sx={{ ...baseButtonSx, ...(page === totalPages ? activeSx : {}) }}
          >
            {totalPages}
          </Box>
        )}
        {page !== totalPages && (
          <Box
            component='button'
            onClick={() => handlePagination(page + 1)}
            type='button'
            sx={{ ...baseButtonSx, ...sidesSx }}
          >
            &gt;
          </Box>
        )}
      </Box>
    </div>
  )
}

export const Pagination = PaginationComponent
